import utility from "src/utils/utility";
import React, { useContext, useEffect, useState } from "react";
import {
  AppSpan,
  AppText,
  CustomContainer,
  FlexColumn,
  FlexRow,
  ScreenContainer,
} from "src/style";
import LeftIcon from "src/assets/svg/back-icon";
import MinusCircle from "src/assets/svg/minus-circle";
import PlusCircle from "src/assets/svg/plus-circle";
import { useNavigate } from "react-router-dom";
import ApiContext from "src/provider/API/call-service";

interface faq {
  question: string;
  answer: string;
}
function FAQ() {
  const navigate = useNavigate();
  const { API } = useContext(ApiContext);
  const [expanded, setExpanded] = useState(0);
  const [faqs, setFaq] = useState<faq[]>();

  useEffect(() => {
    async function fetchFaq() {
      let response = await API.getFaq();
      if (response) setFaq(response);
    }
    fetchFaq();
  }, []);

  console.log("faq", JSON.stringify(faqs));

  const expandFaq = (index: number) => {
    setExpanded(index);
  };
  return (
    <ScreenContainer padding="2.5" bottomPadding="0" topPadding="0">
      <CustomContainer
        customRadius="28px 28px 0px 0px"
        borderColor="#EAECF0"
        minHeight="100"
        mnHUnit="%"
        bgColor="#FCFCFC"
        padding="2"
      >
        <FlexRow>
          <CustomContainer
            width="1"
            onClick={() => {
              navigate(-1);
            }}
          >
            <LeftIcon />
          </CustomContainer>
          <AppSpan textSize="2.2" fontWeight="700" leftMargin="5">
            Frequently Asked Questions
          </AppSpan>
        </FlexRow>

        {faqs && faqs.length > 0 ? (
          faqs?.map((faq, index) => {
            const isExpanded = index === expanded;

            return (
              <CustomContainer
                key={index}
                customRadius="16px"
                topMargin="2"
                borderColor={isExpanded ? "#EAECF0" : undefined}
                minHeight={isExpanded ? "100" : "20"}
                mnHUnit="%"
                bgColor="#FCFCFC"
                padding="2"
                onClick={() => {
                  expandFaq(index);
                }}
              >
                <FlexRow alignItems="flex-start">
                  {isExpanded ? <MinusCircle /> : <PlusCircle />}
                  <FlexColumn leftMargin="2" alignItems="flex-start">
                    <AppText fontWeight="600" textSize="2" bottomMargin="1">
                      {faq?.question}
                    </AppText>
                    {isExpanded && (
                      <AppText fontWeight="400" textSize="1.5">
                        {faq?.answer}
                      </AppText>
                    )}
                  </FlexColumn>
                </FlexRow>
              </CustomContainer>
            );
          })
        ) : (
          <FlexColumn alignItems="center" topMargin="5">
            <AppText fontWeight="600" textSize="2">
              FAQs not available
            </AppText>
          </FlexColumn>
        )}
      </CustomContainer>
    </ScreenContainer>
  );
}
export default utility.routeData("faq", "Faq", <FAQ />);
